import React from "react";

const propertyCode = (property) => property?.resort_code || property?.code || property?.property_code;

const PropertyContextSelector = ({ properties, value, onChange, label = "Property" }) => (
  <label className="flex min-w-[220px] flex-col gap-1 text-sm font-semibold text-slate-700">
    {label}
    <select
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      className="rounded-lg border border-slate-200 bg-white px-3 py-2 font-medium shadow-sm outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
    >
      <option value="" disabled>Select a property</option>
      {properties.map((property) => {
        const code = propertyCode(property);
        return <option key={code || property.resort_id} value={code}>{property.resort_name || code}</option>;
      })}
    </select>
  </label>
);

export { propertyCode };
export default PropertyContextSelector;
